<script>
import CandelaControl from '@/components/controls/CandelaControl'

export default {
  extends: CandelaControl,
  props: {
    item_text: {type: String, default: () => 'text'},
    item_value: {type: String, default: () => 'value'},
    label: {type: String, default: () => 'Untitled'},
    mandatory: {type: Boolean, default: () => false},
    multiple: {type: Boolean, default: () => false},
    items: {type: Array, default: () => []}
  }
}
</script>
<template>
<div class='d-flex align-center'>
  <v-select v-model='value' :items='items'
    :item-text='item_text' :item-value='item_value' :label='label'
    :mandatory='mandatory' :multiple='multiple'
    dense hide-details outlined/>
</div>
</template>
<style lang='sass' scoped>
.v-select
  max-width: 256px
</style>
